import {
  Directive,
  computed,
  input,
} from '@angular/core';
import { BrnDialogDescription } from '@spartan-ng/brain/dialog';
import type { ClassValue } from 'clsx';
import { mergeClasses } from 'src/app/@core/utils/merge-classes';

/**
 * Helm dialog description directive (spartan layer).
 * Apply to a paragraph element inside `hlm-dialog-header` to render the
 * dialog description with muted styling.
 */
@Directive({
  selector: '[hlmDialogDescription]',
  standalone: true,
  hostDirectives: [BrnDialogDescription],
  host: {
    '[class]': '_computedClass()',
  },
})
export class HlmDialogDescriptionDirective {
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _computedClass = computed(() =>
    mergeClasses('text-sm text-muted-foreground', this.userClass()),
  );
}
